import i18n from "src/i18n/config";
import { Certificate } from "src/types/osbuilder";
import { z } from "zod";

const schema = z.object({
    fileId: z.string({ message: i18n.t("common:validation.fieldRequired") }),
    partition: z.enum(["odm", "product", "system", "system_ext", "vendor"]),
    privileged: z.enum(["regular", "privileged"]),
    certificate: z.string().nullable(),
});

const privilegedOptions = [
    { value: "regular", label: i18n.t("modals:manageProductModules.application.input.privileged.options.regular") },
    { value: "privileged", label: i18n.t("modals:manageProductModules.application.input.privileged.options.privileged") },
];
const certificateOptions = [
    { value: "platform", label: i18n.t("modals:manageProductModules.application.input.certificate.options.platform") },
    { value: "presigned", label: i18n.t("modals:manageProductModules.application.input.certificate.options.presigned") },
];

function getCertificateOptions(certificate: Certificate | undefined) {
    if (!certificate || certificateOptions.some((option) => option.value === certificate)) {
        return certificateOptions;
    }
    return [...certificateOptions, { value: certificate, label: certificate }];
}

export default {
    schema,
    privilegedOptions,
    getCertificateOptions,
};
